/**
 * Djay Animation Variants (Framer Motion)
 *
 * Reusable animation presets for Djay mascot interactions.
 * DDD co-locatie: moved from components/mascot/animations/ in s60.
 */

import { Variants } from 'framer-motion';
export const djayVariants: Record<string, Variants> = {
  // @djay-animation: entrance
  entrance: {
    initial: {
      scale: 0,
      opacity: 0
    },
    animate: {
      scale: 1,
      opacity: 1
    },
    transition: {
      type: 'spring',
      stiffness: 300,
      damping: 24,
      duration: 0.3
    }
  },
  // @djay-animation: exit
  exit: {
    animate: {
      scale: 0.8,
      opacity: 0
    },
    transition: {
      duration: 0.2,
      ease: 'easeOut'
    }
  },
  // @djay-animation: bounce (goed antwoord)
  bounce: {
    animate: {
      y: [0, -12, 0]
    },
    transition: {
      duration: 0.3,
      ease: [0.34, 1.56, 0.64, 1]
    }
  },
  // @djay-animation: nod (fout antwoord, bemoedigend)
  nod: {
    animate: {
      rotate: [0, -5, 5, 0],
      scale: [1, 1.05, 1]
    },
    transition: {
      duration: 0.4,
      ease: 'easeInOut'
    }
  },
  // @djay-animation: slideIn (psst hint)
  slideInRight: {
    initial: {
      x: 60,
      opacity: 0,
      scale: 0.8
    },
    animate: {
      x: 0,
      opacity: 1,
      scale: 1
    },
    transition: {
      type: 'spring',
      stiffness: 350,
      damping: 32
    }
  },
  // @djay-animation: celebrate (level up, doel bereikt)
  celebrate: {
    animate: {
      rotate: [0, -10, 10, -10, 0],
      y: [0, -8, 0]
    },
    transition: {
      duration: 0.5,
      ease: 'easeInOut'
    }
  },
  // @djay-animation: tierEvolution (level 6, 11)
  tierEvolution: {
    initial: {
      scale: 1,
      filter: 'brightness(1)'
    },
    animate: {
      scale: [1, 1.2, 0.9, 1.1, 1],
      filter: ['brightness(1)', 'brightness(2)', 'brightness(1)']
    },
    transition: {
      duration: 1.5,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};